export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    if (!src) {
      reject(new Error('No image source provided'));
      return;
    }
    
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      resolve(img);
    };
    img.onerror = (error) => {
      reject(error);
    };
    
    img.src = src;
    
    if (img.complete && img.naturalWidth !== 0) {
      resolve(img);
    }
  });
};

export const preloadImages = (imageSources) => {
  return Promise.all(
    imageSources.map(src => preloadImage(src).catch(() => null))
  );
};

export const getCriticalImages = (baseUrl) => {
  return [
    `${baseUrl}/assets/CM 2.png`,
    `${baseUrl}/assets/DCM 2.png`,
    `${baseUrl}/assets/kannada-Logo.png`,
    `${baseUrl}/assets/English-Logo.png`,
    `${baseUrl}/assets/sample_road.png`,
    `${baseUrl}/assets/BBC_Unit.png`,
    `${baseUrl}/assets/N. A. HARIS.jpg`,
    `${baseUrl}/assets/Atheeq sir.png`
  ];
};

export const getPdfImages = (baseUrl) => {
  return Array.from({ length: 13 }, (_, i) => {
    const pageNum = String(i + 1).padStart(4, '0');
    return `${baseUrl}/pdf_images/BBC Plan Every 5 Km_page-${pageNum}.jpg`;
  });
};

/** Environment clearance JPEGs (same paths as About.js ecl gallery) */
export const getEclPdfImages = (baseUrl) => {
  const stem = 'ECL_AUTH_56O790_IA_KA_INFRA1_405741_2022_page-';
  return Array.from({ length: 11 }, (_, i) => {
    const pageNum = String(i + 1).padStart(4, '0');
    return `${baseUrl}/new pdf images/${stem}${pageNum}.jpg.jpeg`;
  });
};
